import { defineComponent, computed } from "vue";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset-0dfbd395.mjs";
import { u as useLocalConfig, p as provideLocalConfig } from "../../composables/useLocalConfig-624e8425.mjs";
const _sfc_main = defineComponent({
  name: "VaConfig",
  props: {
    ...useComponentPresetProp,
    components: { type: Object, default: () => ({}) }
  },
  setup(props) {
    const prevChain = useLocalConfig();
    const nextChain = computed(() => [...prevChain.value, props.components]);
    provideLocalConfig(nextChain);
    return {};
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=VaConfig.vue_vue_type_script_lang-b032b290.mjs.map
